<app-circular-gauge [size]="size" [strokeWidth]="strokeWidth" [arcs]="arcs"></app-circular-gauge>
